import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BusinessCard from '~/components/profile/BusinessCard.vue';
import Card from '~/components/cards/Card.vue';
import Follow from '~/components/profile/Follow.vue';
import DdButton from '~/components/DdButton.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import BackButton from '~/components/BackButton.vue';
import NavigationBar from '~/components/navigation/NavigationBar.vue';
import ShareButton from '~/components/share/ShareButton.vue';
var socials = [{
  name: 'site',
  icon: 'icon-ic-link',
  title: 'Site',
  mod: 'protocol'
}, {
  name: 'phone',
  icon: 'icon-ic-phone',
  title: 'Phone',
  mod: 'phone'
}, {
  name: 'email',
  icon: 'icon-ic-mail',
  title: 'Email',
  mod: 'email'
}, {
  name: 'facebook',
  icon: 'icon-ic-facebook-circle',
  title: 'Facebook',
  mod: 'protocol'
}, {
  name: 'linkedin',
  icon: 'icon-ic-linkedin',
  title: 'LinkedIn',
  mod: 'protocol'
}, {
  name: 'behance',
  icon: 'icon-ic-behance',
  title: 'Behance',
  mod: 'protocol'
}, {
  name: 'instagram',
  icon: 'icon-ic-instagram',
  title: 'Instagram',
  mod: 'protocol'
}, {
  name: 'dribbble',
  icon: 'icon-ic-dribbble',
  title: 'Dribbble',
  mod: 'protocol'
}, {
  name: 'telegram',
  icon: 'icon-ic-telegram-logo',
  title: 'Telegram',
  mod: 'protocol'
}, {
  name: 'youtube',
  icon: 'icon-ic-play-button',
  title: 'YouTube',
  mod: 'protocol'
}];
export default {
  name: 'ProfileParent',
  scrollToTop: false,
  components: {
    BusinessCard: BusinessCard,
    Card: Card,
    Follow: Follow,
    DdButton: DdButton,
    Dropdown: function Dropdown() {
      return import('~/components/CasesDropdown.vue');
    },
    WebpPicture: WebpPicture,
    BackButton: BackButton,
    NavigationBar: NavigationBar,
    ShareButton: ShareButton,
    Share: function Share() {
      return import('~/components/share/ShareDropdown.vue');
    }
  },
  head: function head() {
    var i18nHead = this.$nuxtI18nHead({
      addSeoAttributes: true
    });
    var title = this.$t('companyPage.title', {
      name: this.profile.displayName || this.profile.name
    });
    var url = "".concat(process.env.baseUrl).concat(this.$route.path);
    var image = "".concat(process.env.baseUrl, "/images/CASES-OG.png");
    if (this.profile.ogImage) image = "".concat(this.profile.ogImage);
    var coverImage = this.profile.coverImage || '/images/companies/generic-cover-1.png';
    var link = [{
      rel: "preload",
      href: coverImage,
      as: "image"
    }].concat(_toConsumableArray(i18nHead.link));
    if (coverImage.match(/^https:\/\/cdn.*\.cases\.media\//)) {
      link[0] = {
        rel: "preload",
        href: "".concat(coverImage, ".webp"),
        as: "image",
        type: "image/webp"
      };
    }
    return {
      title: title,
      link: link,
      meta: [{
        hid: 'title',
        name: "title",
        content: title
      }, {
        hid: 'description',
        name: 'description',
        content: this.description
      }, {
        hid: "og:url",
        property: "og:url",
        content: url
      }, {
        hid: "og:title",
        property: "og:title",
        content: title
      }, {
        hid: "og:description",
        property: "og:description",
        content: this.description
      }, {
        hid: "og:image",
        property: "og:image",
        content: image
      }, {
        hid: "twitter:url",
        name: "twitter:url",
        content: url
      }, {
        hid: "twitter:title",
        name: "twitter:title",
        content: title
      }, {
        hid: "twitter:description",
        name: "twitter:description",
        content: this.description
      }, {
        hid: "twitter:image",
        name: "twitter:image",
        content: image
      }]
    };
  },
  data: function data() {
    return {
      profile: {},
      followers: [],
      counts: {},
      isModer: false,
      topbarVisible: false,
      linksNumber: 5,
      mobileLinks: []
    };
  },
  asyncData: function asyncData(_ref) {
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $axios, route, app, redirect, error, $auth, $appStore, slug, next, data, profile;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            $axios = _ref.$axios, route = _ref.route, app = _ref.app, redirect = _ref.redirect, error = _ref.error, $auth = _ref.$auth, $appStore = _ref.$appStore;
            $appStore.$patch({
              activeApp: 'community'
            });
            slug = route.params.profile; // CASE: /profile
            if (!($auth.user && slug == 'profile')) {
              _context.next = 6;
              break;
            }
            next = "/".concat($auth.user.slug || $auth.user.id);
            return _context.abrupt("return", redirect(app.localePath(next)));
          case 6:
            _context.next = 8;
            return $axios.$get('/profile/get', {
              params: {
                i18n: app.i18n.locale,
                id: slug,
                withCounts: 1 // can't use booleans because javascript is weird
              }
            }).catch(function (e) {
              error({
                statusCode: 404,
                message: 'Профіль не знайдено'
              });
            });
          case 8:
            data = _context.sent;
            profile = data && data.profile;
            if (profile) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", error({
              statusCode: 404,
              message: 'Профіль не знайдено'
            }));
          case 12:
            if (!(profile && profile.slug && profile.slug != slug)) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return", redirect(app.localePath("/".concat(profile.slug))));
          case 14:
            return _context.abrupt("return", {
              profile: profile,
              isModer: data.isModer,
              followers: data.followers || [],
              counts: data.counts || {}
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this = this;
    var mobileLinks = [];
    if (!this.profile.site && this.profile.sites && this.profile.sites[0]) {
      this.profile.site = this.profile.sites[0];
    }
    socials.forEach(function (social) {
      if (_this.profile[social.name]) {
        mobileLinks.push({
          name: social.name,
          icon: social.icon,
          title: social.title,
          link: _this.profile[social.name],
          mod: social.mod
        });
      }
    });
    this.mobileLinks = mobileLinks;
  },
  computed: {
    description: function description() {
      var description = this.$t('head.cases.description');
      if (this.profile.shortAboutMe) return this.profile.shortAboutMe;
      if (this.profile.shortAbout) {
        var locale = this.locale;
        if (!this.profile.shortAbout[this.locale]) {
          locale = this.locale == 'uk' ? 'en' : 'uk';
        }
        if (this.profile.shortAbout[locale]) {
          description = this.profile.shortAbout[locale];
        }
      }
      return description;
    },
    isEmpty: function isEmpty() {
      return !this.counts.posts && !this.counts.companyServices && !this.counts.columns;
    },
    type: function type() {
      return this.profile.type;
    },
    isCompany: function isCompany() {
      return this.type == 'company';
    },
    isUser: function isUser() {
      return this.type == 'user';
    },
    isOwnProfile: function isOwnProfile() {
      return this.$auth.user && this.isUser && this.$auth.user.id == this.profile.id;
    },
    locale: function locale() {
      return this.$i18n.locale || 'uk';
    },
    showPortfolio: function showPortfolio() {
      return this.counts.posts > 0;
    },
    showServices: function showServices() {
      return this.counts.companyServices > 0;
    },
    showArticles: function showArticles() {
      return this.counts.columns > 0;
    },
    showCourses: function showCourses() {
      return this.counts.courses > 0;
    },
    showVacancies: function showVacancies() {
      return this.counts.vacancies > 0;
    },
    canEdit: function canEdit() {
      return this.isModer && this.isCompany || this.isOwnProfile;
    },
    hasHistory: function hasHistory() {
      if (process.server) return false;
      return window.history.length > 2;
    },
    hiddenSocials: function hiddenSocials() {
      if (this.mobileLinks.length <= this.linksNumber) return [];
      var trimIndex = 0 - 1 - this.mobileLinks.length + this.linksNumber;
      return this.mobileLinks.slice(trimIndex);
    },
    location: function location() {
      var location = '';
      if (this.profile.country) location = this.profile.country;
      if (this.profile.city) {
        if (location.length) location = "".concat(location, ", ");
        location = "".concat(location).concat(this.profile.city);
      }
      return location;
    },
    hideHome: function hideHome() {
      if (this.profile.type !== 'user') return false;
      if (this.$auth.user && this.$auth.user.id && this.$auth.user.id == this.profile.id) return false;
      return !this.counts.posts && !this.profile.aboutMe && !this.profile.description && this.counts.columns;
    },
    readersOpen: function readersOpen() {
      return this.$modalityStore.drawer == 'usersList' && this.usersListStore.id == "subs-".concat(this.profile.id);
    },
    usersListStore: function usersListStore() {
      return useUsersListStore();
    }
  },
  mounted: function mounted() {
    if (process.browser) {
      this.observe();
      window.scrollTo(0, 0); // Scroll to top on page visit,
      // but prevent scroll to top on childs navigation
    }
    if (this.hideHome) {
      this.$router.push({
        path: this.localePath("/".concat(this.profile.slug || this.profile.id, "/feed"))
      });
    }
  },
  methods: {
    observe: function observe() {
      var _this2 = this;
      var topBarThreshold = 0.3;
      this.topBarObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var visible = entry.isIntersecting && entry.intersectionRatio >= topBarThreshold;
          _this2.topbarVisible = !visible;
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: topBarThreshold
      });
      var sidebarBlock = document.querySelector('#sidebar-block');
      if (sidebarBlock) this.topBarObserver.observe(sidebarBlock);
    },
    unobserve: function unobserve() {
      if (this.topBarObserver) this.topBarObserver.disconnect();
    },
    showSubscribers: function showSubscribers() {
      this.usersListStore.update({
        id: "subs-".concat(this.profile.id),
        url: '/user/getsubscribers',
        title: 'readers',
        params: {
          model: this.type,
          id: this.profile.id
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unobserve();
  }
};